export default function RoundedPlusIcon ({ strokeColor = "#787D8A", size = "12"}) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 12 12" fill="none">
            <g clipPath="url(#clip0_6020_16073)">
            <path d="M6 3V9" stroke="#787D8A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M3 6L9 6" stroke="#787D8A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <rect x="0.75" y="0.75" width="10.5" height="10.5" rx="2.25" stroke={strokeColor} stroke-width="1.5"/>
            </g>
            <defs>
            <clipPath id="clip0_6020_16073">
            <rect width="12" height="12" fill="white"/>
            </clipPath>
            </defs>
        </svg>
    );
}